/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable newline-after-var */

export const parseResponse = (
  transactions: {},
  is_set_tickets_total_capacity: boolean,
  tickets_total_capacity: number
): {} => {
  let sold_quantity = 0;
  let quantity_expected = 0;
  let merchant_revenue = 0;
  let merchant_ticket_revenue = 0;
  let merchant_revenue_expected = 0;
  let total_capacity = 0;
  
  if (transactions && typeof transactions.sold_quantity === 'number') {
    sold_quantity = transactions.sold_quantity - transactions.return_quantity;
    quantity_expected = transactions.ticket_quantity_expected;
    merchant_revenue = transactions.merchant_revenue - transactions.merchant_revenue_refund;
    merchant_ticket_revenue = transactions.merchant_ticket_revenue - transactions.merchant_ticket_revenue_refund;
    merchant_revenue_expected = transactions.merchant_revenue_expected;

    if (is_set_tickets_total_capacity) {
        total_capacity = Math.min(tickets_total_capacity, quantity_expected);
        quantity_expected = Math.max(total_capacity, sold_quantity);
    }
  }

  return {
    sold_quantity,
    quantity_expected,
    merchant_revenue,
    merchant_ticket_revenue,
    merchant_revenue_expected,
    total_capacity
  };
};
